/* eslint-disable react/prop-types */
import React from 'react';
import HorizontalScroll from '../../shared/HorizontalScroll';
import VideoCard from '../../shared/VideoCard';

function VideoHomeListing({
  data,
  pageSlug,
  paddingClasses = 'pt-[34px] lg:pt-[52px]',
}) {
  return (
    <div className={paddingClasses}>
      <HorizontalScroll className="gap-2">
        <VideoCard
          sectionTitle={data?.getListContents?.list?.name}
          page={data?.getListContents?.list?.name}
          pageSlug={pageSlug}
          videoData={data?.getListContents?.contents}
          entityID={data?.getListContents?.list?.id}
          // filterShow={remoteConfigData.filter}
          wrapperClasses="flex gap-2 lg:grid-cols-3 gap-4"
        />
      </HorizontalScroll>
    </div>
  );
}

export default VideoHomeListing;
